import Message from "./Message"

export default function MessageList({ messages, userData, messagesEndRef }) {
  // Sort messages by creation date to ensure proper chronological order
  const sortedMessages = [...(messages || [])].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

  return (
    <div className="flex-1 p-4 overflow-y-auto bg-[var(--beige-light)]">
      <div className="space-y-4">
        {sortedMessages && sortedMessages.length > 0 ? (
          sortedMessages.map((msg, index) => (
            <Message key={msg._id || index} message={msg} isUser={msg.userId === userData?._id} />
          ))
        ) : (
          <div className="text-center text-gray-500 py-8">No hay mensajes. Envía el primero!</div>
        )}
        <div ref={messagesEndRef} />
      </div>
    </div>
  )
}

